import { Injectable } from '@angular/core';
import {
  CanActivate, UrlTree, Router
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrandGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const storedData = window.localStorage.getItem('partner');
    const slug = storedData ? JSON.parse(storedData).slug : {};

    if (slug === 'telstraplus') {
      return true;
    }
    this.router.navigate(['/not-found']);
    return false;
  }
}
